import React__default from 'react';
import { getStateStyle, getIconSize } from '../utils.js';
import { commonButtonStyle, flexCenterContainer, iconInContainerButtonStyle } from '../commonStyles.css.js';
import { sizeVariants } from './styles.css.js';
import { jsx } from 'react/jsx-runtime';
const IconButton = /*#__PURE__*/React__default.forwardRef(({
  color,
  size,
  icon,
  props,
  className,
  style,
  disabled,
  ...restProps
}, ref) => {
  const iconSizePx = getIconSize(size);
  const dynamicStyle = getStateStyle(color);
  return /*#__PURE__*/jsx("button", {
    className: `${commonButtonStyle({
      size,
      color
    })} ${sizeVariants[size]} ${className ?? ""}`,
    style: { ...dynamicStyle,
      ...style
    },
    disabled: disabled,
    ref: ref,
    ...props,
    ...restProps,
    children: /*#__PURE__*/jsx("div", {
      className: `${flexCenterContainer}`,
      children: /*#__PURE__*/React__default.createElement(icon, {
        sizePx: iconSizePx,
        className: `${iconInContainerButtonStyle({
          color,
          disabled
        })}`
      })
    })
  });
});
IconButton.displayName = "IconButton";
export { IconButton as default };
